import dayjs from "@/lib/helpers/dayjs";
import { durationToString } from "@/utils/momentUtils";

type SessionMetaDataProps = {
  note: {
    call_name?: string;
    session_date?: string;
    session_from?: string;
    session_to?: string;
  };
  patientName?: string;
  // Optional override for the displayed session date (e.g. pre-formatted by caller)
  sessionDate?: string;
};

export function SessionMetaData({ note, patientName, sessionDate }: SessionMetaDataProps) {
  let timing = "";
  let totalDuration = "";

  if (note.session_date && note.session_to && note.session_from) {
    timing = `${note.session_from} to ${note.session_to}`;
    const dayjsTo = dayjs(`${note.session_date} ${note.session_to}`);
    const dayjsFrom = dayjs(`${note.session_date} ${note.session_from}`);
    const diff = dayjs.duration(dayjsTo.diff(dayjsFrom));

    totalDuration = durationToString(diff);
  }

  return (
    <div className="row">
      <div className="col-12 col-lg-6">
        <div>
          <label className="Label">Patient Name</label>
          <p>{patientName}</p>
        </div>
      </div>

      <div className="col-12 col-lg-6">
        <div>
          <label className="Label">Linked Call</label>
          <p>{note.call_name}</p>
        </div>
      </div>

      <div className="col-12 col-lg-6">
        <div>
          <label className="Label">Session Date</label>
          <p>{sessionDate ?? note.session_date}</p>
        </div>
      </div>

      <div className="col-6 col-lg-3">
        <div>
          <label className="Label">Timing</label>
          <p>{timing}</p>
        </div>
      </div>

      <div className="col-6 col-lg-3">
        <div>
          <label className="Label">Duration</label>
          <p>{totalDuration}</p>
        </div>
      </div>
    </div>
  );
}
